import http from "@/services/http";

/**
 * "Encaixe" (fit-in): ao agendar, o paciente sinaliza que aceita ser encaixado
 * mais cedo em certos dias/horário; o assistente vê as pendências.
 */

/** Cria um pedido de encaixe. */
export function createFitInRequest(payload) {
  // payload: { patient_id, doctor_id?, clinic_id?, event_id?, weekdays[], time_from?, time_to?, notes? }
  return http.post("/api/fit-in-requests", payload);
}

/** Pendências de encaixe das clínicas do usuário logado. */
export async function getPendingFitIns() {
  const { data } = await http.get("/api/fit-in-requests/pending");
  return {
    items: data?.data || [],
    pendingCount: data?.pending_count || 0,
  };
}

/** Marca um encaixe como concluído. */
export function resolveFitIn(id) {
  return http.put(`/api/fit-in-requests/${id}/resolve`);
}

/** Remove (cancela) um pedido de encaixe. */
export function deleteFitIn(id) {
  return http.delete(`/api/fit-in-requests/${id}`);
}

/** Dias da semana (valor -> rótulo curto), na ordem seg..dom. */
export const WEEKDAYS = [
  { value: "mon", label: "Seg" },
  { value: "tue", label: "Ter" },
  { value: "wed", label: "Qua" },
  { value: "thu", label: "Qui" },
  { value: "fri", label: "Sex" },
  { value: "sat", label: "Sáb" },
  { value: "sun", label: "Dom" },
];
